module.exports = __webpack_public_path__ + "img/meta.272cfeda.svg";